var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin-top":"10px"}},[_c('section',{staticClass:"main"},[_c('div',{staticClass:"flex"},[_c('OrdersInNominative'),_c('ArticleListingNominativ')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }